export const MATRIX_CLIENT_READY = 'CHAT/MATRIX_CLIENT_READY'
export const MATRIX_UI_READY = 'CHAT/MATRIX_UI_READY'
